export default __webpack_public_path__ + "29b9c616a95a912abf738b3449836608.woff";